import { Box, Typography } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { formatMXN } from "./factoraje.helpers";

interface Props {
  /** Lo que se pidió en el cotizador. */
  solicitado: number;
  /** Lo que suman las empresas registradas. */
  nuevo: number;
}

const labelSx = { fontSize: 10, fontWeight: 700, letterSpacing: "0.09em", textTransform: "uppercase" } as const;
const montoSx = { fontSize: 16, fontWeight: 700, fontVariantNumeric: "tabular-nums", lineHeight: 1.3 } as const;

/** `.fxu-conf` del diseño de Flux: monto de la cotización → monto de la nueva solicitud. */
export const BoxComparacionLinea = ({ solicitado, nuevo }: Props) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 2,
      p: "12px 14px",
      border: "1px solid",
      borderColor: "divider",
      borderRadius: "10px",
      bgcolor: "tokens.surface2",
      color: "tokens.textTertiary",
      textAlign: "left",
    }}
  >
    <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
      <Typography sx={labelSx}>Cotización</Typography>
      <Typography sx={[montoSx, { color: "text.primary" }]}>{formatMXN(solicitado)}</Typography>
    </Box>
    <ArrowForward sx={{ fontSize: 14 }} />
    <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
      <Typography sx={labelSx}>Nueva solicitud</Typography>
      <Typography sx={[montoSx, { color: "primary.accent" }]}>{formatMXN(nuevo)}</Typography>
    </Box>
  </Box>
);
